/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaRigaDTO { 
    id?: string;
    pratica_id?: string;
    codice_pratica?: string;
    posizione?: number;
    codice_fiscale?: string;
    nome?: string;
    cognome?: string;
    punteggio?: number;
    isee?: number;
    punteggio_sportello?: number;
    numero_componenti?: number;
    valore_bonus_riconosciuto?: number;
    valore_bonus_riconosciuto_redistribuito?: number;
    esito?: GraduatoriaRigaDTOEsitoEnum;
    spareggio_fatti?: { [key: string]: any; };
}
export enum GraduatoriaRigaDTOEsitoEnum {
    RICHIESTA_AMMESSA_FINANZIATA = 'RICHIESTA_AMMESSA_FINANZIATA',
    RICHIESTA_AMMESSA_NON_FINANZIATA = 'RICHIESTA_AMMESSA_NON_FINANZIATA'
};



